/** Dual-axis scales for a combo chart (D529): two nice value axes whose gridlines coincide. */
import { extent } from './numbers.js';
import { niceTicks } from './ticks.js';
const MANTISSAS = [1, 2, 2.5, 5];
/** The nice steps (1, 2, 2.5, 5 × 10ⁿ) that are ≥ `min`, ascending, as a generator of candidates. */
function* stepsFrom(min) {
    const exp = Math.floor(Math.log10(min > 0 ? min : 1)) - 1;
    for (let e = exp; e < exp + 40; e += 1) {
        for (const m of MANTISSAS) {
            const s = m * 10 ** e;
            if (s >= min * (1 - 1e-12))
                yield s;
        }
    }
}
const tidy = (n) => Number(n.toPrecision(12));
/**
 * Two axes with the SAME number of intervals so the gridlines line up. The left axis is a regular nice axis; the right one
 * is fitted to the same count with the smallest nice step that covers its range. Each axis includes zero unless told not to.
 */
export function dualAxis(left, right, options = {}) {
    const count = options.ticks ?? 4;
    const range = (values, zero) => {
        const e = extent(values);
        if (e === null)
            return { min: 0, max: 1 };
        return { min: zero ? Math.min(0, e.min) : e.min, max: zero ? Math.max(0, e.max) : e.max };
    };
    const l = range(left, options.includeZeroLeft ?? true);
    const leftTicks = niceTicks(l.min, l.max, count);
    const intervals = Math.max(1, leftTicks.ticks.length - 1);
    const r = range(right, options.includeZeroRight ?? true);
    if (r.max <= r.min)
        r.max = r.min + 1;
    let chosen = null;
    for (const step of stepsFrom((r.max - r.min) / intervals)) {
        const start = Math.floor(r.min / step + 1e-9) * step;
        if (start + intervals * step >= r.max - step * 1e-9) {
            chosen = { step, start };
            break;
        }
    }
    const { step, start } = chosen ?? { step: (r.max - r.min) / intervals, start: r.min };
    const ticks = Array.from({ length: intervals + 1 }, (_, i) => tidy(start + i * step));
    return { left: leftTicks, right: { ticks, domain: [ticks[0] ?? 0, ticks[ticks.length - 1] ?? 1], step: tidy(step) }, intervals };
}
//# sourceMappingURL=combo.js.map